$(document).ready(function() {
	$('.quantity-change').click(function() {
		currentID = ($(this).attr('id'));
      
		currentIDNumber = currentID.substring(currentID.lastIndexOf('-')+1, currentID.length);
		currentDirection = currentID.substring(currentID.indexOf('-')+1, currentID.lastIndexOf('-'));
		currentQuantity = parseInt(document.getElementById('quantity-amount-'+currentIDNumber).innerHTML);
		if(currentDirection == 'minus') {
			currentQuantity -= 1;
		} else {
			currentQuantity += 1;
		}
		if(currentQuantity < 1) currentQuantity = 1;

		oldPrice = parseFloat(document.getElementById('price-current-'+currentIDNumber).innerHTML);
		unitPrice = parseFloat(document.getElementById('price-unit-'+currentIDNumber).innerHTML);
		newPrice = unitPrice * currentQuantity;

        /*if((newPrice+'').indexOf('.') == (newPrice+'').length-2)
          newPriceStr = newPrice+'0';
        else if((newPrice+'').indexOf('.') == -1)
          newPriceStr = newPrice+'.00';
        else*/
          newPriceStr = newPrice+'';

		priceDifference = newPrice - oldPrice;
       
		newTotal = parseFloat(document.getElementById('price-current-total').innerHTML) + priceDifference;

        /*if((newTotal+'').indexOf('.') == (newTotal+'').length-2)
          newTotalStr = newTotal+'0';
        else if((newTotal+'').indexOf('.') == -1)
          newTotalStr = newTotal+'.00';
        else*/
          newTotalStr = newTotal+'';
      
        $.ajax({
           type: "POST",
           url: '/cart/change.js',
           data: { quantity: currentQuantity, id: currentIDNumber },
           success: function(data) {
           },
           dataType: 'application/json'
        });

        cartLink = document.getElementById('menu-link-cart');
        cartText = cartLink.innerHTML;
        itemCountStr = cartText.substring(cartText.indexOf('(')+1, cartText.indexOf(')'));
        itemCount = 1;
        if(!isNaN(itemCountStr)) {
            if((currentDirection == 'minus'))
              itemCount = parseInt(itemCountStr)-1;
            else
              itemCount = parseInt(itemCountStr)+1;
        }
        if(itemCount < 1) itemCount = 1;
        cartLink.innerHTML = 'cart ('+itemCount+')';

        document.getElementById('quantity-hidden-'+currentIDNumber).value = currentQuantity;
		document.getElementById('quantity-amount-'+currentIDNumber).innerHTML = currentQuantity;
		document.getElementById('price-current-'+currentIDNumber).innerHTML = newPriceStr;
		document.getElementById('price-current-total').innerHTML = newTotalStr;
      
	});
});